<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una Zona</option>
        <option v-for="ZonaCivil in ZonasCiviles" :value="ZonaCivil.IdArea">{{ZonaCivil.Abreviatura}}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import {mapActions} from 'vuex'
  import axios from 'axios'

  export default
  {
    data(){
      return {
        enumeraciones,
        comun,
        ZonasCiviles:[],
        idDelModelo: -1
      }
    },//Data
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      parametros: Object,
      idDelInput:String
    },//Props
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerZonaCivil", { llave: this.idDelInput, valor: this.idDelModelo });
    },
    computed: {
      //(:3 000)
    },//Computed
    methods: {
    CargarZonasCiviles(){
      let peticion = {
        EsPrueba: comun.EsPrueba,
      }
      axios.post(api.conexion + api.TemisCivil.catalogos.ZonasCiviles, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.ZonasCiviles = respuesta.data._Zonas;
              this.idDelModelo = this.ZonasCiviles[0].IdArea;
              this.cambiaZonaInicial();
              return respuesta.data._Zonas;
            }
          }).catch(e => {
            console.log(e);
         });
    },
    cambiarDatos: function (event) {
        this.idDelModelo = event.target.value;
        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerZonaCivil", { llave: this.idDelInput, valor: event.target.value});
        this.$emit("valorParaElPadre", event);
      },
    cambiaZonaInicial: function(){
        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerZonaCivil", { llave: this.idDelInput, valor: this.idDelModelo});
        this.$emit("valorParaElPadre", this.idDelModelo);
    }
    },//Methods
    created() {
      this.CargarZonasCiviles();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TemisCivil/Catalogos/ZonasCiviles.vue